import { Component, OnInit } from '@angular/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessageService, SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MockService } from '../../../services/mock.service';

interface BookmarkCategory {
  name: string;
}
@Component({
  selector: 'app-role-bookmarks',
  standalone: true,
  imports: [InputSwitchModule, SharedModule, TableModule, ToastModule],
  templateUrl: './role-bookmarks.component.html',
  styleUrl: './role-bookmarks.component.scss',
})
export class RoleBookmarksComponent implements OnInit {
  access = false;
  categories!: BookmarkCategory[];
  selectedCategories!: BookmarkCategory;

  constructor(
    private mockService: MockService,
    private messageService: MessageService
  ) {}

  /**
   * Lifecycle method called after Angular has initialized all data-bound properties of the directive.
   * This method retrieves bookmarks data using the mockService and assigns it to the categories property.
   *
   * @return {void} No return value for this lifecycle hook.
   */
  ngOnInit(): void {
    this.mockService.getBookmarks().then(data => {
      this.categories = data;
    });
  }

  /**
   * Toggles the access state between granted and denied. Updates the message service with the current access status.
   *
   * @return {void} Does not return a value.
   */
  accessToggle(): void {
    this.access = !this.access;
    this.messageService.add(
      this.access
        ? {
            severity: 'success',
            summary: 'Aktualisiert',
            detail: 'Zugriff gewährt',
          }
        : {
            severity: 'error',
            summary: 'Aktualisiert',
            detail: 'Zugriff verweigert',
          }
    );
  }
}
